var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rag-settings" }, [
    _c("div", { staticClass: "section-title" }, [
      _vm._v(_vm._s(_vm.$t("chatbotv2.ragMethod"))),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "rag-method-cards" }, [
      _c(
        "div",
        {
          staticClass: "rag-card",
          class: { selected: _vm.ragMethod === "openai-rag" },
          on: {
            click: function ($event) {
              return _vm.selectRagMethod("openai-rag")
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "rag-card-header" },
            [
              _c("img", {
                staticClass: "rag-logo",
                attrs: {
                  src: "https://openai.com/favicon.ico",
                  onerror: "this.style.display='none'",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "rag-card-title" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.openaiRag"))),
              ]),
              _vm._v(" "),
              _vm.ragMethod === "openai-rag"
                ? _c("a-tag", { attrs: { color: "green" } }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.active"))),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "rag-card-desc" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("chatbotv2.openaiRagDesc")) +
                "\n            "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "rag-card",
          class: { selected: _vm.ragMethod === "supsis-rag" },
          on: {
            click: function ($event) {
              return _vm.selectRagMethod("supsis-rag")
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "rag-card-header" },
            [
              _c("div", { staticClass: "rag-card-title" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.supsisRag"))),
              ]),
              _vm._v(" "),
              _c("a-tag", { attrs: { color: "blue" } }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.new"))),
              ]),
              _vm._v(" "),
              _vm.ragMethod === "supsis-rag"
                ? _c("a-tag", { attrs: { color: "green" } }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.active"))),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "rag-card-desc" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("chatbotv2.supsisRagDesc")) +
                "\n            "
            ),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.ragMethod === "supsis-rag"
      ? _c("div", { staticClass: "supsis-rag-config" }, [
          _c(
            "div",
            { staticClass: "config-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.openRouterChannel")) + " "),
                _c("span", { staticClass: "required" }, [_vm._v("*")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-desc" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.openRouterChannelDesc"))),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: _vm.$t("chatbotv2.selectOpenRouterChannel"),
                  },
                  on: { change: _vm.saveOpenrouterChannel },
                  model: {
                    value: _vm.openrouterChannel,
                    callback: function ($$v) {
                      _vm.openrouterChannel = $$v
                    },
                    expression: "openrouterChannel",
                  },
                },
                _vm._l(_vm.openrouterChannels, function (ch) {
                  return _c(
                    "a-select-option",
                    { key: ch._id, attrs: { value: ch._id } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(ch.name) +
                          "\n                    "
                      ),
                      ch.payload && ch.payload.keyMode === "byok"
                        ? _c("span", { staticStyle: { color: "#1890ff" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("chatbotv2.ragChannelBadgeByok"))
                            ),
                          ])
                        : _c("span", { staticStyle: { color: "#52c41a" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("chatbotv2.ragChannelBadgeSupsis"))
                            ),
                          ]),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _vm.openrouterChannels.length === 0
                ? _c(
                    "div",
                    { staticClass: "no-channel-warn" },
                    [
                      _c("a-alert", {
                        attrs: {
                          type: "warning",
                          "show-icon": "",
                          message: _vm.$t("chatbotv2.noOpenRouterChannel"),
                          description: _vm.$t(
                            "chatbotv2.createOpenRouterChannelDesc"
                          ),
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "config-section" }, [
            _c("div", { staticClass: "section-title" }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.embeddingModel"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "section-desc" }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.embeddingModelDesc"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "embedding-model-cards" },
              _vm._l(_vm.embeddingModels, function (em) {
                return _c(
                  "div",
                  {
                    key: em.id,
                    staticClass: "embedding-card",
                    class: { selected: _vm.embeddingModel === em.id },
                    on: {
                      click: function ($event) {
                        return _vm.selectEmbeddingModel(em.id)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "embedding-card-header" },
                      [
                        _c("span", { staticClass: "model-name" }, [
                          _vm._v(_vm._s(em.name)),
                        ]),
                        _vm._v(" "),
                        em.recommended
                          ? _c("a-tag", { attrs: { color: "green" } }, [
                              _vm._v(_vm._s(_vm.$t("chatbotv2.recommended"))),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "model-meta" }, [
                      _c("span", [_vm._v(_vm._s(em.contextLength) + " token")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(em.dimensions) + " boyut")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "model-desc" }, [
                      _vm._v(_vm._s(em.description)),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.saved
      ? _c(
          "div",
          { staticClass: "save-info" },
          [
            _c("a-alert", {
              attrs: {
                type: "success",
                message: "RAG ayarları kaydedildi.",
                "after-close": function () {
                  return (_vm.saved = false)
                },
                closable: "",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }